export const PAYMENT_PROCESSOR_NOT_SETUP = "Payment processor not setup";
